/* dj-sticky-atc.js — show the mobile sticky add-to-cart when the real ATC scrolls off,
   forward its click to Dawn's add-to-cart, and mirror price + sold-out state. */
(function () {
  var bar = document.querySelector('[data-dj-sticky-atc]');
  if (!bar) return;

  var mainBtn = document.querySelector('.product-form__submit');
  var anchor = mainBtn || document.querySelector('.product-form__buttons');
  if (!anchor) return;

  var stickyBtn = bar.querySelector('[data-dj-sticky-add]');
  var stickyPrice = bar.querySelector('[data-dj-sticky-price]');
  var mainPrice =
    document.querySelector('.product__info-container .price') ||
    document.querySelector('.price');

  var shown = false;

  function show() {
    if (shown) return;
    shown = true;
    bar.hidden = false;
    requestAnimationFrame(function () { bar.classList.add('is-visible'); });
  }

  function hide() {
    if (!shown) return;
    shown = false;
    bar.classList.remove('is-visible');
    var done = function (ev) {
      if (ev && ev.propertyName !== 'transform') return;
      if (!shown) bar.hidden = true;
      bar.removeEventListener('transitionend', done);
    };
    bar.addEventListener('transitionend', done);
  }

  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      if (!e.isIntersecting && e.boundingClientRect.top < 0) show();
      else hide();
    }, { threshold: 0 }).observe(anchor);
  }

  if (stickyBtn) {
    stickyBtn.addEventListener('click', function () {
      if (mainBtn && !mainBtn.hasAttribute('disabled')) mainBtn.click();
    });
  }

  function sync() {
    if (mainPrice && stickyPrice) {
      var node = mainPrice.querySelector('.price-item--regular') || mainPrice;
      var t = (node.textContent || '').trim();
      if (t) stickyPrice.textContent = t;
    }
    if (mainBtn && stickyBtn) {
      var disabled = mainBtn.hasAttribute('disabled');
      stickyBtn.disabled = disabled;
      stickyBtn.style.opacity = disabled ? '0.5' : '';
    }
  }

  sync();

  if ('MutationObserver' in window) {
    if (mainPrice) {
      new MutationObserver(sync).observe(mainPrice, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    }
    if (mainBtn) {
      new MutationObserver(sync).observe(mainBtn, {
        attributes: true,
        attributeFilter: ['disabled'],
      });
    }
  }
})();
